import 'react'
import { Outlet } from 'react-router-dom'

import { SeeMyTrainingRequestsDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'

import { RequestsComponent } from 'modules/trainings/components/MyTrainings/RequestsComponent'
import { Provider } from 'modules/trainings/components/MyTrainings/RequestsComponent/MyRequestsDataTable/Provider'

const Requests = () => {
  const { search, onSearch } = useDebouncedSearch()
  const { loading, data } = useQuery(SeeMyTrainingRequestsDocument)
  const seeCatalog = !!data?.trainings._policies.trainingsSeeCatalog.can
  const employees = data?.employees.employeeNames ?? []
  if (loading) return <></>
  return (
    <AuthorizeUser authorizeFn={() => seeCatalog}>
      <Provider search={search} employees={employees}>
        <RequestsComponent search={search} onSearch={onSearch} />
        <Outlet />
      </Provider>
    </AuthorizeUser>
  )
}

export default Requests
